<template>
    <div class="price-lists-results">
        <div class="price-lists-results__container">
            <p class="price-lists-results__count" v-html="resultCount"></p>
            <z-table
                :columns="[text.period, text.fileName, text.size]"
            >
                <z-table-row
                    v-for="(item, index) in data"
                    :key="index"
                >
                    <z-table-col index="0">
                        <span class="price-lists-results__text" v-html="item.period"></span>
                    </z-table-col>
                    <z-table-col index="1">
                        <z-link class="price-lists-results__link" :href="item.link" theme="black">
                            <z-icon name="file/xls" width="24" height="24"></z-icon>
                            {{ item.name }}
                        </z-link>
                    </z-table-col>
                    <z-table-col index="2">
                        <span class="price-lists-results__text" v-html="filterSize(item.size)"></span>
                    </z-table-col>
                </z-table-row>
            </z-table>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import { filterSize } from '@/utils/mixin'

export default {
    name: 'results',
    mixins: [filterSize],
    props: {
        data: {
            type: Array,
            default: () => []
        },
        nav: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            text: {
                period: localize({
                    ru: 'Период',
                    en: 'Period'
                }),
                fileName: localize({
                    ru: 'Наименование документа',
                    en: 'File name'
                }),
                size: localize({
                    ru: 'Размер',
                    en: 'Size'
                })
            }
        }
    },
    computed: {
        resultCount () {
            if (this.nav.count === null) return ''
            if (this.nav.count === 0) return ''

            const start = localize({
                ru: ['найден', 'найдено', 'найдено'],
                en: ['found', 'found', 'found']
            })
            const end = localize({
                ru: ['прайс-лист', 'прайс-листа', 'прайс-листов'],
                en: ['price-list', 'price-lists', 'price-lists']
            })

            let stringStart = this.declOfNum(this.nav.count, start)
            let stringEnd = this.declOfNum(this.nav.count, end)

            return `${stringStart} ${this.nav.count} ${stringEnd}`
        }
    },
    methods: {
        declOfNum (number, titles) {
            let cases = [2, 0, 1, 1, 1, 2]

            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
        }
    }
}
</script>

<style lang="scss">
.price-lists-results {

    &__count {
        margin-bottom: $token-spacers-m;
    }

    &__text {
        white-space: nowrap;
    }

    &__link {
        > span {
            display: flex;
            align-items: center;
            font-weight: 500;
            align-items: flex-start;
        }

        .z-icon {
            flex-shrink: 0;
            margin-right: $token-spacers-s;
            margin-top: 3px;
        }
    }
}
</style>
